import React, { useEffect, useState } from 'react'
import { useParams } from "react-router-dom";
import { BiCheckCircle, BiSpreadsheet } from 'react-icons/bi';
import { BsCartCheckFill } from "react-icons/bs";
import { TbTruckDelivery } from "react-icons/tb";
import serverurl from '../utils/ServerUrl';
import Breadcrumb from '../components/ShearedComponents/Breadcrumb';


export default function TrackOrder() {
    const [successData, setSuccessData] = useState([])
    const [loading, setLoading] = useState(true)
    const { id } = useParams();
    // const tranId ="e36a2bfe-af18-4a0f-86b3-33f67d591764";

    useEffect(() => {
        window.scrollTo(0, 0)
        fetch(`${serverurl}/orders/track/${id}`)
            .then(response => response.json()).then((res) => {
                setSuccessData(res)
                setLoading(false)

            })
            .catch((err) => {
                console.log(err.message)
            });
    }, [id])

    const initialProgressState = [
        { i: "accepted", status: false },
        { i: "prepared", status: false },
        { i: "ready", status: false },
        { i: "delivered", status: false }
    ]
    const [progresData, setProgresData] = useState(initialProgressState);

    useEffect(() => {
        if (successData && loading === false) {
            updateState()
        }
    }, [successData, loading]);

    const updateState = () => {

        if (successData?.progressStatus === "accepted") {
            setProgresData([
                { i: "accepted", status: true },
                { i: "prepared", status: false },
                { i: "ready", status: false },
                { i: "delivered", status: false }
            ])
        }
        else if (successData?.progressStatus === "prepared") {
            setProgresData([
                { i: "accepted", status: true },
                { i: "prepared", status: true },
                { i: "ready", status: false },
                { i: "delivered", status: false }
            ])
        }
        else if (successData?.progressStatus === "ready") {
            setProgresData([
                { i: "accepted", status: true },
                { i: "prepared", status: true },
                { i: "ready", status: true },
                { i: "delivered", status: false }
            ])
        }
        else if (successData?.progressStatus === "delivered") {
            setProgresData([
                { i: "accepted", status: true },
                { i: "prepared", status: true },
                { i: "ready", status: true },
                { i: "delivered", status: true }
            ])
        }

    };

    // console.log(progresData)

    if (loading) { return (<div>loading..</div>) }

    return (
        <div className='bg-gray-200'>
            <div className='container mx-auto  sm:p-0 md:p-5'>
                <Breadcrumb page="My Orders" name="Track your order"  link={true} />
                <div className="bg-white px-5 pt-5 my-2">
                    <ol className="items-center sm:flex">
                        {
                            progresData.map((data, i) => (
                                <li key={i} className="relative mb-6 sm:mb-0">
                                    <div className="flex items-center">
                                        <div className={`flex z-10 justify-center items-center w-7 h-7 ${data.status === true ? 'bg-green-200' : 'bg-gray-200'} rounded-full ring-0 ring-white sm:ring-8 shrink-0`}>
                                            {data.status === true ?
                                                <BiCheckCircle className='text-4xl font-bold text-green-600' />
                                                :
                                                (
                                                    data.i === "prepared" ?
                                                        <BiSpreadsheet className={`w-4 h-4 ${data.status === true ? 'text-green-600' : 'text-gray-500'}`} />
                                                        : (data.i === "ready" ?
                                                            <BsCartCheckFill className={`w-4 h-4 ${data.status === true ? 'text-green-600' : 'text-gray-500'} `} />
                                                            : (data.i === "delivered" ?
                                                                <TbTruckDelivery className={`w-4 h-4 ${data.status === true ? 'text-green-600' : 'text-gray-500'} `} />
                                                                : data.i === "prepared" &&
                                                                <BiSpreadsheet className={`w-4 h-4 ${data.status === true ? 'text-green-600' : 'text-gray-500'} `} />
                                                            ))
                                                )
                                            }
                                        </div>
                                        <div className={`hidden sm:flex w-full ${data.status === true ? 'bg-green-600' : 'bg-gray-500'} h-1 `}></div>
                                    </div>
                                    <div className="mt-3 sm:pr-8">
                                        <h3 className="text-lg font-semibold text-gray-900 "> Order is being {data.i}</h3>
                                        <time className="block mb-2 text-sm font-normal leading-none text-gray-400">------------</time>
                                        <p className=" bg-white text-white">Get started with dozens of web components and interactive elements.</p>
                                    </div>
                                </li>
                            ))
                        }
                    </ol>

                </div>
                <div className='bg-white grid grid-cols-5 pt-5 p-4'>
                    <div className='md:col-span-2 col-span-5'>
                        <div className='bg-gray-50 mt-3 p-3'>
                            <div className="mark-icon text-center">
                                <div className='w-full flex justify-center'>
                                    <BiCheckCircle className='text-4xl font-bold text-green-600' />
                                </div>
                                <h3 className='text-2xl font-normal text-gray-600 mb-3'>Thank you for your online purchase</h3>
                                <p className='t text-gray-600'>This is a confirmation and summary of your order which is currently being {successData?.progressStatus}.</p>
                            </div>
                            <div className='p-4'>
                                {
                                    [successData].map((item) => (
                                        <ul className="list-disc">
                                            <li className='text-gray-600 font-poppins text-sm pb-1'>Order Id : <span className='font-semibold'>{item?._id}</span></li>
                                            <li className='text-gray-600 font-poppins text-sm pb-1'>Date : <span className='font-semibold'>{item?.PlacedDate}</span></li>
                                            <li className='text-gray-600 font-poppins text-sm pb-1'>Email : <span className='font-semibold'>{item?.contactInfo.email}</span></li>
                                            <li className='text-gray-600 font-poppins text-sm pb-1'>Total : <span className='font-semibold'>{item?.totalPrice} BDT</span></li>
                                            <li className='text-gray-600 font-poppins text-sm pb-1'>Order Number : <span className='font-semibold'>Cash On Delivery</span></li>
                                        </ul>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                    <div className='grid md:col-span-3 col-span-5  mt-3 md:p-3'>
                        <h3 className='text-2xl font-poppins text-gray-500 pb-3 mb-2 border-b'>Order Details</h3>
                        {/* ///////////////////////////////////////////////////////////////////// */}


                        <table className="table-auto w-full">
                            <thead>
                                <tr className='border-b-2'>
                                    <th className='w-28 pb-3 pt-1.5 px-3 font-poppins font-semibold text-sm text-gray-600 '></th>
                                    <th className='w-48 pb-3 pt-1.5 px-2 font-poppins font-semibold text-sm text-gray-600'>Name</th>
                                    <th className='w-24 pb-3 pt-1.5 px-2 font-poppins font-semibold text-sm text-gray-600'>quantity</th>
                                    <th className='w-20 pb-3 pt-1.5 px-2 font-poppins font-semibold text-sm text-gray-600 md:block hidden'>price</th>
                                    <th className='w-20 pb-3 pt-1.5 px-3 font-poppins font-semibold text-sm text-gray-600 text-end'>total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {successData?.itemIds?.length > 0 ?
                                    successData?.itemIds.map((item, i) => (
                                        <tr key={i} className='border-b'>
                                            <td className=''>
                                                <img className='h-16 md:m-2 object-contain' src={item.img} alt="" />
                                            </td>
                                            <td className='text-gray-600 py-3 px-2 md:text-base text-xs'>{item.name.length > 32 ? (item.name.substring(32, 0) + "..") : item.name}</td>
                                            <td className='text-center p-3 md:text-base text-xs'>{item.quantity}</td>
                                            <td className='md:block text-center relative md:-top-8 md:text-base text-xs'>{item.price}</td>
                                            <td className='text-end py-3 pr-3 md:text-base text-xs'>{item.total}</td>
                                        </tr>
                                    ))
                                    :
                                    <div className='p-3 text-center w-full'>
                                        <h3 className='text-center w-full'>Empty 😊</h3>
                                    </div>
                                }

                            </tbody>
                        </table>
                        {/* //////////////////////////////////////////////////////////////////////// */}
                        <div>
                            <div className='py-2 mt-1 px-3'>
                                <h3 className='text-2xl text-gray-600 font-poppins'>Bill Address</h3>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.address}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.addressFillds[0].split(' ')[1]}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.addressFillds[1].split(' ')[1]}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.addressFillds[2].split(' ')[1]}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.addressFillds[3].split(' ')[1]}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.contactInfo?.phone}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.contactInfo?.email}</p>
                            </div>
                            <div className='py-2 px-3'>
                                <h3 className='text-2xl text-gray-600 font-poppins'>Shipping Address</h3>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.address}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.addressFillds[0].split(' ')[1]}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.addressFillds[1].split(' ')[1]}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.addressFillds[2].split(' ')[1]}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.deliveryAddress?.addressFillds[3].split(' ')[1]}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.contactInfo?.phone}</p>
                                <p className='text-gray-600 italic text-sm mb-1 font-normal font-poppins'>{successData?.contactInfo?.email}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
